import { useSelector } from 'react-redux'
import useCurrentUserProp from 'hooks/useCurrentUserProp'

export default function useCurrentUserEntities(entityName, userRelation = null) {
  const entityIds = useCurrentUserProp(userRelation || entityName)
  const selectedEntities = useSelector(({ entities }) => entities[entityName])
  return entityIds.map((id) => selectedEntities[id])
}
